export default function SolutionsSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Our Comprehensive Solutions for Landlords
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We've developed specialized solutions for every situation landlords face when selling tenant occupied real estate.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 mb-16">
          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/ed86dd462adcca925eab67c2cdfe8485.jpg"
              alt="Tenant Occupied Property Solutions"
              className="w-full h-auto rounded-lg shadow-2xl object-cover"
            />
          </div>

          <div className="space-y-6">
            <div className="bg-gradient-to-br from-teal-50 to-white p-6 rounded-xl border-l-4 border-teal-600">
              <h3 className="text-2xl font-bold text-gray-900 mb-3">For Properties with Good Tenants</h3>
              <p className="text-gray-700 leading-relaxed">
                If you have reliable, paying tenants with valid leases, we honor those agreements. Your tenants can stay, and we take over as the new landlord. This creates a smooth transition with minimal disruption. You get paid quickly, tenants keep their homes, and everyone benefits.
              </p>
            </div>

            <div className="bg-gradient-to-br from-teal-50 to-white p-6 rounded-xl border-l-4 border-teal-600">
              <h3 className="text-2xl font-bold text-gray-900 mb-3">For Properties with Problem Tenants</h3>
              <p className="text-gray-700 leading-relaxed">
                Dealing with difficult tenants, non-paying occupants, or lease violations? We buy these properties too. We have the experience and resources to handle challenging tenant situations after closing. You walk away from the problem, and we take it from there.
              </p>
            </div>

            <div className="bg-gradient-to-br from-teal-50 to-white p-6 rounded-xl border-l-4 border-teal-600">
              <h3 className="text-2xl font-bold text-gray-900 mb-3">For Properties Needing Repairs</h3>
              <p className="text-gray-700 leading-relaxed">
                Deferred maintenance is common with rental properties. We buy tenant occupied real estate in any condition—no repairs required. Whether it needs minor updates or major renovations, we make our offer based on current condition and handle improvements after purchase.
              </p>
            </div>

            <div className="bg-gradient-to-br from-teal-50 to-white p-6 rounded-xl border-l-4 border-teal-600">
              <h3 className="text-2xl font-bold text-gray-900 mb-3">For Complex Lease Situations</h3>
              <p className="text-gray-700 leading-relaxed">
                Multiple units with different lease terms? Month-to-month tenants? Section 8 vouchers? Commercial and residential mix? We handle all types of lease complexity. Our team reviews every lease and structures offers that work for your specific situation.
              </p>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl p-12 text-white">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-3xl font-bold mb-6">Every Situation is Unique</h3>
              <p className="text-gray-300 mb-6 leading-relaxed">
                We understand that every rental property and tenant situation is different. That's why we don't use a one-size-fits-all approach. We take time to understand your specific circumstances, challenges, and goals.
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Whether you're retiring from landlording, relocating, dealing with inheritance, facing financial pressure, or simply ready to cash out your investment, we have solutions that work.
              </p>
              <p className="text-gray-300 leading-relaxed">
                Our experience with over 200 rental property purchases means we've seen it all—and we know how to handle it professionally and efficiently.
              </p>
            </div>
            <div className="relative">
              <img 
                src="https://readdy.ai/api/search-image?query=diverse%20rental%20property%20portfolio%20single%20family%20homes%20duplexes%20apartment%20buildings%20tenant%20occupied%20real%20estate%20investment%20properties%20various%20types&width=700&height=800&seq=rental-solution-002&orientation=portrait"
                alt="We Buy All Types of Rental Property"
                className="w-full h-auto rounded-lg shadow-2xl object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}